import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/audit/")({
    beforeLoad: ({ search }) => {
        throw redirect({ to: "/audit/change-timeline", search, replace: true });
    },
});
